export default __webpack_public_path__ + "static/all-caps-do-fa528e00013592070e807c6cda905eb08500c5a6d1a60f40c5be35027d805c77.png";